goog.provide("shadow.js.shim.module$src$svg$inform$cross_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$cross_svg");
shadow.js.shim.module$src$svg$inform$cross_svg = shadow.js.nativeProvides["src/svg/inform/cross.svg"] = shadow$bridge("src/svg/inform/cross.svg");
module$shadow_js_shim_module$src$svg$inform$cross_svg.default = shadow.js.shim.module$src$svg$inform$cross_svg;
